<template>

<van-tabs animated v-model:active="StoreActiveChoiceCoAWithTime" shrink line-width="80">

<van-tab :disabled="StoreActiveChoiceCoA != 0" >
  <template #title>{{ $t('Type de connecteur') }}</template>
  <SelectTypeCoA />
</van-tab>

<SelectChaussette v-if="StoreCoAChoose"/>

<van-tab :disabled="StoreActiveChoiceCoA != 1" 
  v-if="!shouldUseAutoDiametre && StoreCoAChoose != 'NU' && StoreActiveChoiceCoA == 1">
  <template #title>{{ $t('Diamètre des gaines d’extrémités') }} </template>
  <SelectDiametreCoA v-if="StoreCoAChoose"/>
</van-tab>

<SelectAutoDiametreCoA v-if="shouldUseAutoDiametre && StoreCoAChoose"/>

<SelectNuDiametreCoA v-if="(StoreCodeRefStructureFamille != 'SLSOH' && StoreCoAChoose == 'NU' )"/>



<!--
<van-tab>
  <template #title>Chaussette</template>
  <SelectDiametreCoA v-if="StoreCoAChoose" />
</van-tab>

<van-tab>
  <template #title>Diamètre</template>
  <SelectDiametreCoA v-if="StoreChaussette && StoreCoAChoose" />
</van-tab>
-->
</van-tabs>

<br/>

</template>
    
    
    <script>
  import SelectTypeCoA from './SelectTypeCoA.vue'
  import SelectDiametreCoA from './SelectDiametreCoA.vue'
  import SelectAutoDiametreCoA from './SelectAutoDiametreCoA.vue'
  import SelectNuDiametreCoA from './SelectNuDiametreCoA.vue'
  import SelectChaussette from './SelectChaussette.vue'
    export default {
      components: {
        SelectTypeCoA,
        SelectDiametreCoA,
        SelectAutoDiametreCoA,
        SelectChaussette,
        SelectNuDiametreCoA
      },
      data() {
        return {
          StoreActiveChoiceCoAWithTime: 0,
        }
      },
      watch: {
        // à chaque fois que la question change, cette fonction s'exécutera
        StoreActiveChoiceCoA: function (data) {
          setTimeout(() => this.StoreActiveChoiceCoAWithTime = data, 50);
          //setTimeout(this.testtest(data), 30000);

          },
        },
      computed: {
        StoreActiveChoiceCoA(){
   
          if( Object.keys(this.$store.state.storeCoA.coA).length > 1 )
              {
                return 1
              }
              else{
                return Object.keys(this.$store.state.storeCoA.coA).length
              }
              
        },
            /** Choix type conencteur A */
            StoreCableStructureChoose() {
              return this.globalFunction.existKeyInArray("structure", this.$store.state.storeCable.cable) 
              ? true
              : null 
            },
            /** Choix type conencteur A */
            StoreCoAChoose() {
              return this.globalFunction.existKeyInArray("type", this.$store.state.storeCoA.coA) 
              ? this.$store.state.storeCoA.coA.type.TypeCoA
              : null 
            },
            /** Mode de fibre */
            StoreModeFibre() {
              return this.globalFunction.existKeyInArray("type", this.$store.state.storeCable.cable) 
              ? this.$store.state.storeCable.cable.type.ModeFibre
              : null 
            },
            /** Code ref struc famille */
            StoreCodeRefStructureFamille() {
              return this.globalFunction.existKeyInArray("structure", this.$store.state.storeCable.cable) 
              ? this.$store.state.storeCable.cable.structure.codeRefStructureFamille
              : null 
            },
            shouldUseAutoDiametre() {
              return this.StoreCodeRefStructureFamille == 'SLSOH' || 
                     (this.globalFunction.existKeyInArray("nombre", this.$store.state.storeCable.cable) && 
                      this.$store.state.storeCable.cable.nombre.nbFibre === 48);
            },
            StoreNbFibre() {
              return this.globalFunction.existKeyInArray("nombre", this.$store.state.storeCable.cable) 
                ? this.$store.state.storeCable.cable.nombre.nbFibre
                : null;
            },
          }
   
    
    }

    </script>